import type { FC } from "react";

import classNames from "classnames";

import { FireIcon } from "@jti/brand-icons/fire";
import { TimeIcon } from "@jti/brand-icons/time";
import { Badge } from "@jti/core-components/components/Badge";

export type TimeLimitedBadgeProps = {
  theme: "dark-theme" | "light-theme";
  label?: string;
  isDisabled: boolean;
  className?: string;
  isMoreThanOneDay?: boolean;
};

export const TimeLimitedBadge: FC<TimeLimitedBadgeProps> = ({
  theme,
  label,
  isDisabled,
  className,
  isMoreThanOneDay,
}: TimeLimitedBadgeProps) => {
  if (!label || isDisabled) return null;

  return (
    <div className={classNames(className, theme)}>
      <Badge
        label={label}
        data-testid="timeLimitedBadge"
        icon={isMoreThanOneDay ? TimeIcon : FireIcon}
        variant={isMoreThanOneDay ? "ghost" : "neutral-bold"}
      />
    </div>
  );
};
